import {
  mdiFormatRotate90
} from '@mdi/js'

export default {
  type: String,
  default: mdiFormatRotate90
}
